import {
  ArrowDownIcon,
  ArrowUpIcon,
  GearIcon,
  TrashIcon,
} from '@phosphor-icons/react';
import { T } from 'gt-react';
import {
  DropdownMenuItem,
  DropdownMenuSeparator,
} from '@/components/ui/dropdown-menu';

/** Move and settings. Rendered only when the user can update the page. */
export function SidebarPageEditItems({
  canMoveUp,
  canMoveDown,
  moving,
  onMoveUp,
  onMoveDown,
  onChangeSettings,
}: {
  canMoveUp: boolean;
  canMoveDown: boolean;
  moving: boolean;
  onMoveUp: () => void;
  onMoveDown: () => void;
  onChangeSettings: () => void;
}) {
  return (
    <>
      <DropdownMenuItem
        disabled={moving || !canMoveUp}
        onClick={onMoveUp}
        data-testid="sidebar-page-move-up"
      >
        <ArrowUpIcon />
        <T context="sidebar page context menu item that moves the page up one position">
          Move up
        </T>
      </DropdownMenuItem>
      <DropdownMenuItem
        disabled={moving || !canMoveDown}
        onClick={onMoveDown}
        data-testid="sidebar-page-move-down"
      >
        <ArrowDownIcon />
        <T context="sidebar page context menu item that moves the page down one position">
          Move down
        </T>
      </DropdownMenuItem>
      <DropdownMenuItem
        disabled={moving}
        onClick={onChangeSettings}
        data-testid="sidebar-page-settings"
      >
        <GearIcon />
        <T context="sidebar page context menu item that opens the page editor">
          Change settings
        </T>
      </DropdownMenuItem>
    </>
  );
}

/** Remove. Rendered only when the user can delete the page. */
export function SidebarPageRemoveItem({
  separated,
  moving,
  onRemove,
}: {
  separated: boolean;
  moving: boolean;
  onRemove: () => void;
}) {
  return (
    <>
      {separated && <DropdownMenuSeparator />}
      <DropdownMenuItem
        variant="destructive"
        disabled={moving}
        onClick={onRemove}
        data-testid="sidebar-page-remove"
      >
        <TrashIcon />
        <T context="sidebar page context menu item that removes the page from the sidebar">
          Remove
        </T>
      </DropdownMenuItem>
    </>
  );
}
